import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const handleToggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleCloseMenu = () => {
    setIsMenuOpen(false);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleToggleMenu();
    }
  };

  const navLinks = [
    { path: '/', label: 'Start' },
    { path: '/test', label: 'AI Teaching Assistant' },
    { path: '/manage-vta', label: 'Manage Teaching Assisant' },
    { path: '/create-agent', label: 'AI Agents' },
    { path: '/create-orchestration-agent', label: 'Orchestration Agent' },
    { path: '/accessibility-agent', label: 'Accessibility' },
    { path: '/it-helpdesk-agent', label: 'IT Workforce' },
    { path: '/workday-assistant', label: 'Workday Assistant' },
    { path: '/recruiting-workforce', label: 'Recruiting' },
    { path: '/explore-marketplace', label: 'Marketplace' },
    { path: '/security-and-data-protection', label: 'Architecture' },
    { path: '/educause', label: 'EDUCAUSE' }
  ];

  return (
    <nav className="bg-purple-700 text-white px-3 sm:px-4 py-2 sm:py-3 shadow-lg">
      <div className="w-full mx-auto flex justify-between px-2">
        {/* Logo - Left Side (Desktop & Mobile) */}
        <Link
          to="/"
          className="flex items-center text-decoration-none flex-shrink-0"
          onClick={handleCloseMenu}
          aria-label="Go to home page"
        >
          <img
            src="/CampusMind-white.svg"
            alt="CampusMind"
            className="h-8 sm:h-10 md:h-12"
          />
        </Link>

        {/* Desktop Navigation - Right Side */}
        <div className="hidden md:flex md:space-x-2 lg:space-x-4 xl:space-x-6 flex-wrap items-center justify-end">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              onClick={handleCloseMenu}
              className={`px-2 md:px-3 py-2 rounded-lg transition-all duration-200 hover:text-purple-200 hover:bg-purple-600 whitespace-nowrap text-sm lg:text-base ${location.pathname === link.path
                ? 'text-purple-200 font-semibold bg-purple-600 border-2 border-purple-300 shadow-md'
                : 'text-white'
                }`}
              aria-label={`Navigate to ${link.label} page`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        {/* Mobile Hamburger Menu */}
        <div className="md:hidden">
          <button
            className={`hamburger ${isMenuOpen ? 'active' : ''} flex flex-col justify-center items-center w-8 h-8`}
            onClick={handleToggleMenu}
            onKeyDown={handleKeyDown}
            aria-label="Toggle navigation menu"
            aria-expanded={isMenuOpen}
            tabIndex={0}
          >
            <span className={`block w-6 h-0.5 bg-white transition-all duration-300 ${isMenuOpen ? 'rotate-45 translate-y-1.5' : ''}`}></span>
            <span className={`block w-6 h-0.5 bg-white transition-all duration-300 mt-1 ${isMenuOpen ? 'opacity-0' : ''}`}></span>
            <span className={`block w-6 h-0.5 bg-white transition-all duration-300 mt-1 ${isMenuOpen ? '-rotate-45 -translate-y-1.5' : ''}`}></span>
          </button>
        </div>

        {/* Mobile Menu Overlay */}
        <div
          className={`fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity duration-300 md:hidden ${isMenuOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
            }`}
          onClick={handleCloseMenu}
        >
          <div
            className="fixed right-0 top-0 h-full w-64 sm:w-80 bg-white shadow-xl transform transition-transform duration-300 z-50 overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
            style={{ transform: isMenuOpen ? 'translateX(0)' : 'translateX(100%)' }}
          >
            <div className="flex items-center justify-between p-4 border-b border-gray-200">
              <Link
                to="/"
                className="flex items-center text-decoration-none"
                onClick={handleCloseMenu}
                aria-label="Go to home page"
              >
                <img
                  src="/CampusMind-white.svg"
                  alt="CampusMind"
                  className="h-8 mr-4"
                />
              </Link>
              <button
                className="close-menu text-2xl text-gray-600 hover:text-gray-800"
                onClick={handleCloseMenu}
                aria-label="Close menu"
                tabIndex={0}
              >
                ×
              </button>
            </div>
            <div className="p-4 space-y-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={handleCloseMenu}
                  className={`block py-3 px-4 rounded-lg transition-all duration-200 ${location.pathname === link.path
                    ? 'bg-purple-600 text-white font-semibold border-2 border-purple-300 shadow-md'
                    : 'text-gray-700 hover:bg-gray-100 hover:text-gray-900'
                    }`}
                  aria-label={`Navigate to ${link.label} page`}
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation; 
